import { Component } from 'react';
import { ConfigProp, IsReadyToRenderProp, RenderPropWithProps } from '../../../../common/types/prop-types/common';
import { config } from '../../../common/';

export interface MainLayoutProps extends IsReadyToRenderProp, ConfigProp {}

export interface MainLayoutContainerProps { }

export default class MainLayoutContainer extends Component<MainLayoutContainerProps & RenderPropWithProps<MainLayoutProps>> {
    public isReadyToRender(): boolean {
        return true;
    }

    public render() {
        const newProps: MainLayoutProps = {
            isReadyToRender: this.isReadyToRender(),
            config,
        };
        return this.props.children(newProps);
    }
}
